import { Link } from "react-router-dom";

const articles = [
  {
    category: "Trading Education",
    title: "Understanding Futures Markets: A Beginner's Guide for Diaspora Investors",
    excerpt: "Futures trading offers powerful tools for wealth creation, but requires disciplined education. Here's how to start your journey the right way.",
    date: "March 28, 2026",
    readTime: "6 min read",
    img: "/assets/images/site/insight001-600x400.jpg",
  },
  {
    category: "Wealth Strategy",
    title: "Cross-Border Wealth Planning for the African Diaspora: Key Considerations",
    excerpt: "Managing assets across multiple jurisdictions requires careful planning. We break down the essential frameworks for diaspora families.",
    date: "March 15, 2026",
    readTime: "8 min read",
    img: "/assets/images/site/insight002-600x400.jpg",
  },
  {
    category: "Nairobi Markets",
    title: "Why East Africa's Capital Markets Are Attracting Global Diaspora Capital",
    excerpt: "From the Nairobi Securities Exchange to private equity, East Africa's investment landscape is maturing rapidly. Here's what you need to know.",
    date: "February 28, 2026",
    readTime: "5 min read",
    img: "/assets/images/site/insight003-600x400.jpg",
  },
];

export default function InsightsPreview() {
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-widest mb-3">
              Knowledge Hub
            </span>
            <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F]">
              Insights &amp; Resources
            </h2>
          </div>
          <Link
            to="/insights"
            className="inline-flex items-center gap-2 text-[#1A4D3C] font-medium text-sm hover:text-[#C9A961] transition-colors whitespace-nowrap cursor-pointer"
          >
            View all resources <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {articles.map((article) => (
            <article key={article.title} className="group cursor-pointer">
              <div className="aspect-video overflow-hidden rounded-lg mb-5">
                <img
                  src={article.img}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-widest mb-3">
                {article.category}
              </span>
              <h3 className="font-['Cormorant_Garamond'] text-xl font-bold text-[#2B2D2F] mb-3 group-hover:text-[#1A4D3C] transition-colors leading-snug">
                {article.title}
              </h3>
              <p className="text-[#6B6B6B] text-sm leading-relaxed mb-4 font-['Inter']">{article.excerpt}</p>
              <div className="flex items-center gap-3 text-xs text-[#9B9B9B] font-['Inter']">
                <span>{article.date}</span>
                <span>&bull;</span>
                <span>{article.readTime}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
